export default {
  envStr: 'prodUs1',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://doc.us1.fenydata.com',
}